import React, { useCallback, useEffect } from 'react';

import PhoneVerificationCodeModal from '@/modules/user/components/Verification/PhoneVerificationModal/PhoneVerificationCodeModal';
import useSendVerificationCodeQuery from '@/modules/user/components/Verification/queries/useSendVerificationCode.query';
import { VerificationType } from '@/modules/user/components/Verification/verification.types';

interface Props {
  phoneNumber: string;
  onSetVisible: (value: boolean) => void;
  onBack: () => void;
  onNext: (verificationType: VerificationType) => void;
}

const PhoneNumberVerificationModal: React.FC<Props> = ({ phoneNumber, onSetVisible, onBack, onNext }) => {
  const { sendVerificationCode } = useSendVerificationCodeQuery();

  const handleSendVerificationCode = useCallback(async () => {
    await sendVerificationCode({
      type: VerificationType.SMS,
      value: phoneNumber || ''
    });
  }, [phoneNumber, sendVerificationCode]);

  const handleNext = useCallback(() => {
    onNext(VerificationType.SMS);
  }, [onNext]);

  useEffect(() => {
    handleSendVerificationCode();
  }, [phoneNumber, handleSendVerificationCode]);

  return (
    <PhoneVerificationCodeModal
      phoneNumber={phoneNumber}
      onSetVisible={onSetVisible}
      onBack={onBack}
      onNext={handleNext}
    />
  );
};

export default PhoneNumberVerificationModal;
